import React, { useEffect } from 'react';
import useModal from '../../hooks/useModal';
import { QuizItem, QuizTypes } from '../../types/quiz';
import { useQuizContext } from '../../context/QuizContext';
import QuizStartModalNew from './QuizStartModalNew';

type Props = { nodeIDs: number[] };

const getQuizType = (quizType: QuizTypes | null) => {
  switch (quizType) {
    case 'flashcards':
      return 'FLASHCARD';
    case 'questions':
      return 'QUESTION';
    default:
      return 'NA';
  }
};

/**
 * Wrapper for the quiz start modal.
 */
const QuizStartWrapper = (props: Props) => {
  const { nodeIDs } = props;
  const quizModal = useModal<{ items: number[] }>();
  const { setQuiz, quizType } = useQuizContext();

  // Show modal on mount
  useEffect(() => {
    quizModal.show();
  }, []);

  return (
    <QuizStartModalNew
      modalProps={quizModal}
      onStart={(items: QuizItem[]) => {
        setQuiz(items.map((item) => ({ item })));
        quizModal.hide();
      }}
      quizType={getQuizType(quizType)}
      items={nodeIDs}
    />
  );
};

export default QuizStartWrapper;
